const html = {
    "microdata":[
        {   
            "name":"Open Graph",
            "img": "",
            "thumbnail": "openGraph.svg",
            "link":"http://ruogp.me/",
            "hint": ""
        },
        {   
            "name":"Schema",
            "img": "",
            "thumbnail": "schema.svg",
            "link":"http://schema.org/docs/schemas.html",
            "hint": ""
        },
        {   
            "name":"Testing",
            "img": "",
            "thumbnail": "404.svg",
            "link":"https://search.google.com/structured-data/testing-tool",
            "hint": ""
        }
    ],
    "gridLayouts": [
         {   
            "name":"Materialize",
            "img": "",
            "thumbnail": "materialize.svg",
            "link": "http://materializecss.com/",
            "hint": ""
        },
        {   
            "name":"Bootstrap",
            "img": "",
            "thumbnail": "bootstrap.svg",
            "link": "http://getbootstrap.com/",
            "hint": ""
        },
        {   
            "name":"Foundation",
            "img": "",
            "thumbnail": "foundation.svg",
            "link":"https://foundation.zurb.com/",
            "hint": ""
        }
    ],
    "preprocessers": [
        {   
            "name":"htmlbook",
            "img": "",
            "thumbnail": "htmlbook.svg",
            "link":"http://htmlbook.ru/css",
            "hint": ""
        },
        {   
            "name":"sass",
            "img": "",
            "thumbnail": "sass.svg",
            "link":"http://sass-lang.com/",
            "hint": ""
        },
        {   
            "name":"stylus",
            "img": "",
            "thumbnail": "stylus.svg",
            "link":"http://stylus-lang.com/",
            "hint": ""
        }
    ],
    "metodology": [
        {
            "name":"BEM",
            "img": "",
            "thumbnail": "bem.svg",
            "link":"https://css-tricks.com/bem-101/",
            "hint": ""
        }
    ],
    "semantic": [
        {
            "name":"htmlbook",
            "img": "",
            "thumbnail": "htmlbook.svg",
            "link":"http://htmlbook.ru/html",
            "hint": "ru"
        },
        {
            "name":"<head>",
            "img": "",
            "thumbnail": "head.svg",
            "link":"https://github.com/joshbuchea/HEAD",
            "hint": "en"
        },
        {
            "name":"Flexbox",
            "img": "",
            "thumbnail": "flexbaox.svg",
            "link":"http://html5.by/blog/flexbox/",
            "hint": "ru"
        },
        {
            "name":"Box Shadow Effects",
            "img": "",
            "thumbnail": "404.svg",
            "link":"https://paulund.co.uk/learn-css-box-shadow",
            "hint": ""
        }
    ]
}

export default html;


// WEBPACK FOOTER //
// ./src/assets/db/html+css.js